import $ from 'jquery';
import accordion from "../../resources/js/modules/accordion";
import initSelectsForBlock from "../../resources/js/modules/formSelects";

accordion(
  $('.two-columns-block .accordion-block .accordion-block__item > .accordion-title'),
  '.two-columns-block .accordion-block .accordion-block__item > .accordion-text',
  'active-block-text-acc',
  'active-block-btn-acc',
  true
);

initSelectsForBlock('.two-columns-block', [
    {
        selector: ".two-columns-block .gfield.from-country .ginput_container_select select",
        flagText: themeVars.fromTextForFlagInput,
    },
    {
        selector: ".two-columns-block .to-country .ginput_container_select select",
        flagText: themeVars.toTextForFlagInput,
    },
]);